



































































































import { nameId } from '@/store/interfaces/generic';
import {
  PermissionGroupParams,
  Permissions
} from '@/store/interfaces/PermissionGroup';
import { SectionsGroupParams } from '@/store/interfaces/PermissionSections';
import root from '@/store/types/root';
import Vue, { PropType } from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'NewPermissionGroupForm',
  props: {
    sectionsGroup: {
      required: true,
      type: Array as PropType<SectionsGroupParams[]>,
    },
    permissionsGroup: {
      required: false,
      type: Object as PropType<PermissionGroupParams>,
    },
  },
  data: () => {
    return {
      kind: 0,
      kindOptions: [
        {
          name: 'De personal',
          id: 0,
        },
        {
          name: 'De compañia',
          id: 1,
        }
      ] as nameId[],
      model: {
        name: '',
        permission_ids: [],
      } as { name: string; permission_ids: string[] },
      permissionRequired: false,
      messageButton: 'Agregar',
      defaultKind: 1,
    };
  },
  computed: {
    ...mapGetters({
      getProcess: root.getters.GET_START_PROCESS,
    }),
    sectionsGroupSync: {
      get(): SectionsGroupParams[] {
        return this.sectionsGroup;
      },
      set(value: SectionsGroupParams[]): void {
        this.$emit('sectionsGroup', value);
      },
    },
    disabledSelect(): boolean {
      return this.$route.name === 'edit-group-permission';
    },
  },
  mounted(): void {
    if (Object.keys(this.permissionsGroup).length > 0) {
      this.model.permission_ids = this.permissionsGroup.permissions.map(
        (value: Permissions) => value.id
      );
      this.model.name = this.permissionsGroup.name;
      this.messageButton = 'Actualizar permisos';
      this.defaultKind = this.permissionsGroup.kind === 'staff' ? 1 : 2;
    }
  },
  methods: {
    isActive(persmission_id: string): boolean {
      if (this.model.permission_ids.includes(persmission_id)) {
        return true;
      }
      return false;
    },
    permissionId(id: string): void {
      const isInclude = this.model.permission_ids.indexOf(id);
      if (isInclude === -1) {
        this.model.permission_ids.push(id);
      } else {
        this.model.permission_ids.splice(isInclude, 1);
      }
    },
    newPermissionGroup(): void {
      if (this.model.permission_ids.length === 0) {
        this.permissionRequired = true;
      } else {
        this.permissionRequired = false;
        this.$emit('input', this.model);
      }
    },
    returnPermissionList(): void {
      this.$router.push({
        name: 'permissions',
      });
    },
  },
  watch: {
    kind: {
      deep: true,
      handler(value: number): void {
        this.$emit('kindGroup', value);
      },
    },
  },
});
